import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import hdfc from "../assets/images/hdfc.png";
import NaviFaqItems from "./NaviFaqItems";
import ObPfHoldingsBase from "./ObPfHoldingsBase";
import { getAllBonds } from "../services/waitlist-service";
import { toast } from "react-toastify";
import moment from "moment";

export default function ObPfHoldings(props) {
  const [isBonds, setIsBonds] = useState(false)

  const { isMobile } = props;


  const redirectToProduct = (product, productType) => {
    window.location.href = `/platform/#/biddeasy-asset/${productType}/${product}`;
  };

  useEffect(()=>{
    Object.keys(props.holdings).map((item)=>{
      props?.bondDetails?.filter((e) => e.product === item)[0]
                          ?.productType === "bonds" && setIsBonds(true)
    })
  },[])

  return (
    <>
      <Container
        style={
          props.isMobile ? { paddingLeft: "2px", paddingRight: "2px" } : {}
        }
      >
        {isBonds && 
          Object.values(props?.holdings).some(item => item.pfStats.matured === false && item.productType === "bonds") &&   
          <p className="font-weight-semi-bold w-100 header">Bonds</p>
        }

        {!isMobile ? (
          Object.keys(props.holdings).map((item) => (
            props?.bondDetails?.filter((e) => (e.product === item && !props.holdings[item].pfStats.matured))[0]?.productType === 'bonds' &&
            <Row>
              {
                <div className="holding-outer">
                  <ObPfHoldingsBase
                    title={
                      props?.bondDetails?.filter((e) => e.product === item)[0]
                        ?.issuer
                    }
                    img={
                      props?.bondDetails?.filter((e) => e.product === item)[0]
                        ?.logoUrl
                    }
                    firstCard={true}
                    isMobile={isMobile}
                  />
                  <ObPfHoldingsBase
                    title="Current Value"
                    value={(props.holdings[item].pfStats.mtm).oroNumber(2, true)}
                    isMobile={isMobile}
                    isRedemptionAllowed={(props?.bondDetails.find(e => e.product === item) || {}).isRedemptionAllowed}
                    productType={props?.holdings[item]?.productType}
                    productName={props?.holdings[item]?.product}
                  />

                  <ObPfHoldingsBase
                    title="Amount Invested"
                    value={(props.holdings[item].pfStats.userInvestedAmnt).oroNumber(2, true)}
                    isMobile={isMobile}
                  />
                  <ObPfHoldingsBase
                    title="XIRR"
                    value={(props.holdings[item].userXirr)+'% p.a.'}
                    isMobile={isMobile}
                  />
                  <ObPfHoldingsBase
                    title="Maturity Date"
                    value={
                      props.bondDetails.filter((e) => e.product === item).length ? 
                      new moment(new Date(props.bondDetails.filter((e) => e.product === item)[0]
                      .maturityDate)).format("Do MMM YYYY") : null
                    }
                    isMobile={isMobile}
                  />
                  <span
                    className="view"
                    onClick={() => redirectToProduct(item, props.holdings[item].productType)}
                  >
                    View Details
                  </span>
                </div>
              }
            </Row>
          ))
        ) : (
          <div>
            {Object.keys(props.holdings).map((item) => (
              props?.bondDetails?.filter((e) => e.product === item && !props.holdings[item].pfStats.matured)[0]?.productType === 'bonds' &&
              <div>
              <div className="holding-outer">
                <ObPfHoldingsBase
                  title={
                    props?.bondDetails?.filter((e) => e.product === item)[0]
                      ?.issuer
                  }
                  img={
                    props?.bondDetails?.filter((e) => e.product === item)[0]
                      ?.logoUrl
                  }
                  firstCard={true}
                  isMobile={isMobile}
                />

                <div className="hr"></div>

                <div className="wrapper">
                  <ObPfHoldingsBase
                    title="Current Value"
                    value={(props.holdings[item].pfStats.mtm).oroNumber(2, true)}
                    isMobile={isMobile}
                    isRedemptionAllowed={(props?.bondDetails.find(e => e.product === item) || {}).isRedemptionAllowed}
                    productType={props?.holdings[item]?.productType}
                    productName={props?.holdings[item]?.product}
                  />

                  <ObPfHoldingsBase
                    title="Amount Invested"
                    value={(props.holdings[item].pfStats.userInvestedAmnt).oroNumber(2, true)}
                    isMobile={isMobile}
                  />
                  <ObPfHoldingsBase
                    title="XIRR"
                    value={(props.holdings[item].userXirr)+'% p.a.'}
                    isMobile={isMobile}
                  />
                  <ObPfHoldingsBase
                    title="Maturity Date"
                    value={
                      props.bondDetails.filter((e) => e.product === item).length ? 
                      new moment(new Date(props.bondDetails.filter((e) => e.product === item)[0]
                      .maturityDate)).format("Do MMM YYYY") : null
                    }
                    isMobile={isMobile}
                  />
                </div>
                <span className="view" onClick={() => redirectToProduct(item, props.holdings[item].productType)}>
                  View Details
                </span>
              </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </>
  );
}
